import {useCallback, useEffect, useState} from 'react';

import type {TabItem} from './types';

const useTabs = (tabs: TabItem[], queryKey?: string) => {
  const [currentTab, setCurrentTab] = useState<TabItem>(() => {
    if (queryKey) {
      const searchParams = new URLSearchParams(window.location.search);
      const tabId = searchParams.get(queryKey);
      const matchedTab = tabs.find((tab) => tab.id === tabId);
      if (matchedTab) {
        return matchedTab;
      }
    }
    return tabs[0];
  });

  useEffect(() => {
    if (queryKey) {
      const searchParams = new URLSearchParams(window.location.search);
      const tabId = searchParams.get(queryKey);
      const matchedTab = tabs.find((tab) => tab.id === tabId);
      const nextTab = matchedTab ?? tabs[0];

      if (nextTab && nextTab.id !== currentTab.id) {
        setCurrentTab(nextTab);
      }
    }
  }, [queryKey, tabs, currentTab.id]);

  const handleTabChange = useCallback(
    (tab: TabItem) => {
      if (queryKey) {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set(queryKey, tab.id);

        // Update URL without reloading the page
        window.history.replaceState(
          null,
          '',
          `${window.location.pathname}?${searchParams.toString()}`,
        );
      }
      setCurrentTab(tab);
    },
    [queryKey],
  );

  return {currentTab, handleTabChange};
};

export default useTabs;
